import React from "react";

export const AlertModalContext = React.createContext();

const withAlertModalContext = (Component) => (props) => (
  <AlertModalContext.Consumer>
    {(contextProps) => <Component {...{ ...props, context: contextProps }} />}
  </AlertModalContext.Consumer>
);

export default withAlertModalContext;
